/*
================================================================ 
		 Copyright (c) 2018-2021 Digitize Things Inc.           
					 All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import { connect } from "react-redux";
import Input from "../../../component/inputpm";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import stateCode from "../../../helper/stateCode";
import InputPhone from "../../../component/inputPhone";
import { withTranslation } from "react-i18next";
import FormControlLabel from "@mui/material/FormControlLabel";
import Loader from "../../../component/loader";
import Button from "../../../component/button";
import Collapse from "@mui/material/Collapse";
import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import FormControl from "@mui/material/FormControl";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";
import Delete from "@mui/icons-material/Delete";
import actionTypes from "../../../store/actions";
import Tooltip from "@mui/material/Tooltip";
import classes from "./customer.module.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getStatesList } from "../../../helper/getStateList.js";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
// import { withStyles } from '@mui/styles';
// import Select from '@mui/material/Select';

const styles = {
  resizablePaper: {
    resize: "both",
    overflow: "auto",
    minWidth: 640,
    minHeight: 200,
    maxWidth: "90vw",
    maxHeight: "90vh",
    width: "60vw",
  },
};
class AddressDetails extends Component {
  state = {
    openAddressDetails: false,
    //displayForm: false,

    //basic address fileds
    attention: "",
    phone: "",
    street1: "",
    street2: "",
    city: "",
    state: "",
    zip: "",
    country: this.props.defaultCountry,

    //address array
    addressDetails: [],
    loading: false,
    postalMechId: "",

    billingDetails: {},
    shippingDetails: {},

    //set primary
    isPrimary: false,

    //dialog
    dialogTitle: "",
    addAddressDetailDialog: false,
    editAddressDetailDialog: false,
    selectedBillingAddress: "",

    addressError: {
      message: "",
      show: false,
    },
    error: {},
    statesList: [],
    loading: false,
  };

  componentDidMount() {
    this.setState(
      {
        addressDetails: this.props.addressDetails,
      },
      () => {
        this.state.addressDetails.map((address, i) => {
          address.openAddressDetails = false;
        });
      },
    );
  }

  setOpen = (value, index) => {
    let addressDetails = [...this.state.addressDetails];
    addressDetails[index].openAddressDetails = value;
    this.setState({
      addressDetails: addressDetails,
    });
  };

  updateCustomerAddress = () => {
    if (this.validateForm()) {
      this.setState({ loading: true });
      let details = {};
      if (this.props.tabValue === 1) {
        details = {
          shipping: {
            attention: this.state.attention,
            phone: this.state.phone,
            street1: this.state.street1,
            street2: this.state.street2,
            city: this.state.city,
            state: this.state.state,
            zip: this.state.zip,
            country: this.state.country,
            postalMechId: this.state.postalMechId,
          },
          billing: {
            attention: "",
            phone: "",
            street1: "",
            street2: "",
            city: "",
            state: "",
            zip: "",
            country: "",
          },
        };
      } else if (this.props.tabValue === 2) {
        details = {
          billing: {
            attention: this.state.attention,
            phone: this.state.phone,
            street1: this.state.street1,
            street2: this.state.street2,
            city: this.state.city,
            state: this.state.state,
            zip: this.state.zip,
            country: this.state.country,
            postalMechId: this.state.postalMechId,
          },
          shipping: {
            attention: "",
            phone: "",
            street1: "",
            street2: "",
            city: "",
            state: "",
            zip: "",
            country: "",
          },
        };
      }
      let updateDate = {
        contact: {
          firstName: "",
          lastName: "",
          partyId: "",
          officePhone: "",
          mobilePhone: "",
          email: "",
          emailMechId: "",
          mobilePhoneMechId: "",
          officePhoneMechId: "",
          billingCloseDay: "",
        },
        billing: details.billing,
        shipping: details.shipping,
        banDetails: {
          accountName: "",
          ban: "",
          isManaged: this.props.customerDetails.isManaged,
        },
      };
      //when sales channel creates the profile for the customer
      if (
        this.props.providerType === "SALES_CHNL_PROVIDER" &&
        (this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
          this.props.loggedInUserType !== "ECOMMERCE_ADMIN")
      ) {
        updateDate.contact.partyId = this.props.customerDetails.partyId;
        updateDate.banDetails.ban = this.props.customerDetails.ban;
        updateDate.banDetails.accountName =
          this.props.customerDetails.accountName;
      }

      BusApiCall("POST", `${constants.busInternalUrl}/customers`, updateDate)
        .then((res) => {
          if (res.data.responseMessage === "success") {
            this.setState({
              addressError: {
                message: "",
                show: false,
              },
            });
            //get the payment details to set after adding a new one
            let customerId = "";
            if (
              this.props.customerDetails &&
              this.props.providerType === "SALES_CHNL_PROVIDER" &&
              (this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                this.props.loggedInUserType !== "ECOMMERCE_ADMIN")
            ) {
              customerId = this.props.customerDetails.partyId;
            }
            BusApiCall(
              "GET",
              `${constants.busV4Url}/myProfile?customerId=${customerId}`,
            )
              .then((res) => {
                if (this.props.tabValue === 1) {
                  this.setState(
                    {
                      addressDetails: res.data.shipping,
                    },
                    () => {
                      this.setState({
                        loading: false,
                        editAddressDetailDialog: false,
                      });
                    },
                  );
                } else if (this.props.tabValue === 2) {
                  this.setState(
                    {
                      addressDetails: res.data.billing,
                    },
                    () => {
                      this.setState({
                        loading: false,
                        editAddressDetailDialog: false,
                      });
                    },
                  );
                }
                this.props.setErrorMessage(
                  this.props.t("ADDRESS_UPDATED_SUCCESSFULLY"),
                  true,
                );
              })
              .catch((err) => {
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  this.props.setErrorMessage(err.response.data.message, false);
                } else {
                  this.props.setErrorMessage(
                    this.props.t("DEFAULT_ERROR_MESSAGE"),
                    false,
                  );
                }
                this.setState({
                  loading: false,
                  editAddressDetailDialog: false,
                });
              });
            // this.setState({ loading: false })
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
            editAddressDetailDialog: false,
          });
        });
    }
  };

  updateChange = (e, index) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    // let addressDetails = [...this.state.addressDetails]
    // addressDetails[index][e.target.name] = e.target.value
    // this.setState({
    //     addressDetails : addressDetails,
    // })
  };

  setAddress = (e) => {
    // console.log('e.target.name: e.target.value', e.target.name, e.target.value)
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  setPrimaryMethod = (e) => {
    this.setState({
      isPrimary: !this.state.isPrimary,
    });
  };

  addAddressDetails = () => {
    this.setState({
      displayForm: true,
    });
  };

  hideAddressDetails = () => {
    this.setState({
      displayForm: false,
    });
  };

  setPrimaryAddress = (e, index) => {
    let addressDetails = [...this.state.addressDetails];
    addressDetails[index][e.target.name] = e.target.checked;
    this.setState(
      {
        addressDetails: addressDetails,
        [e.target.name]: e.target.checked,
      },
      () => {
        //call api
      },
    );
  };

  validateForm = () => {
    const error = {};
    let t = this.props.t;
    let addressError = {
      message: "",
      show: false,
    };
    if (!this.state.attention) {
      error.attention = t("ATTENTION_NAME_IS_REQUIRED");
    }
    if (!this.state.street1) {
      error.street1 = t("STREET1_IS_REQUIRED");
      // } else if (!this.state.phone) {
      //     addressError = {
      //         message: t('PHONE_NUMBER_IS_REQUIRED'),
      //         show: true
      //     }
      //     this.setState({ loading: false })
    }
    if (this.state.phone) {
      if (!this.validateMobileNumber(this.state.phone)) {
        error.phone = t("PHONE_IS_INVALID");
      }
    }
    if (!this.state.city) {
      error.city = t("CITY_IS_REQUIRED");
      // } if (!this.state.zip) {
      // 	error.zip = t('ZIP_IS_REQUIRED');
    }
    if (!this.state.state) {
      error.state = t("STATE_IS_REQUIRED");
    }
    if (!this.state.country) {
      error.country = t("COUNTRY_IS_REQUIRED");
    }
    this.setState({ error });
    // this.setState({
    // 	loading: false
    // })
    if (Object.keys(error).length === 0) {
      return true;
    }
  };

  createCustomerProfile = (e) => {
    if (this.validateForm()) {
      this.setState({ loading: true });
      let details = {};
      if (this.props.tabValue === 1) {
        details = {
          shipping: {
            attention: this.state.attention,
            phone: this.state.phone,
            street1: this.state.street1,
            street2: this.state.street2,
            city: this.state.city,
            state: this.state.state,
            zip: this.state.zip,
            country: this.state.country,
            isPrimary:
              this.state.addressDetails.length === 0
                ? true
                : this.state.isPrimary,
          },
          billing: {
            attention: "",
            phone: "",
            street1: "",
            street2: "",
            city: "",
            state: "",
            zip: "",
            country: "",
          },
        };
      } else if (this.props.tabValue === 2) {
        details = {
          billing: {
            attention: this.state.attention,
            phone: this.state.phone,
            street1: this.state.street1,
            street2: this.state.street2,
            city: this.state.city,
            state: this.state.state,
            zip: this.state.zip,
            country: this.state.country,
            isPrimary:
              this.state.addressDetails.length === 0
                ? true
                : this.state.isPrimary,
          },
          shipping: {
            attention: "",
            phone: "",
            street1: "",
            street2: "",
            city: "",
            state: "",
            zip: "",
            country: "",
          },
        };
      }

      let newData = {
        contact: {
          firstName: "",
          lastName: "",
          partyId: "",
          officePhone: "",
          mobilePhone: "",
          email: "",
          emailMechId: "",
          mobilePhoneMechId: "",
          officePhoneMechId: "",
          billingCloseDay: "",
        },
        billing: details.billing,
        shipping: details.shipping,
        banDetails: {
          accountName: "",
          ban: "",
        },
      };

      //when sales channel creates the profile for the customer
      if (
        this.props.providerType === "SALES_CHNL_PROVIDER" &&
        (this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
          this.props.loggedInUserType !== "ECOMMERCE_ADMIN")
      ) {
        newData.contact.partyId = this.props.customerDetails.partyId;
        newData.banDetails.ban = this.props.customerDetails.ban;
        newData.banDetails.accountName = this.props.customerDetails.accountName;
      }
      //Create new customer
      BusApiCall("POST", `${constants.busInternalUrl}/customers`, newData)
        .then((res) => {
          this.setState({
            addressError: {
              message: "",
              show: false,
            },
          });
          let addressDetails = [...this.state.addressDetails];
          if (res.data.responseMessage === "success") {
            if (this.props.tabValue === 1) {
              if (newData.shipping.isPrimary) {
                for (let i = 0; i < this.state.addressDetails.length; i++) {
                  this.state.addressDetails[i].isPrimary = false;
                }
              }
              addressDetails.push({
                attention: newData.shipping.attention,
                street1: newData.shipping.street1,
                street2: newData.shipping.street2,
                phone: newData.shipping.phone,
                city: newData.shipping.city,
                state: newData.shipping.state,
                zip: newData.shipping.zip,
                country: newData.shipping.country,
                isPrimary: newData.shipping.isPrimary,

                phoneMechId: res.data.customer.shipping.phoneMechId,
                postalMechId: res.data.customer.shipping.postalMechId,
              });
              this.setState(
                {
                  addressDetails: addressDetails,
                  shippingDetails: addressDetails,
                },
                () => {
                  this.setState({
                    addAddressDetailDialog: false,
                    displayForm: false,
                    loading: false,
                  });
                  this.handleDialog(false);
                  this.props.reloadCustomerData();
                },
              );
            } else if (this.props.tabValue === 2) {
              if (newData.billing.isPrimary) {
                for (let i = 0; i < this.state.addressDetails.length; i++) {
                  this.state.addressDetails[i].isPrimary = false;
                }
              }
              addressDetails.push({
                attention: newData.billing.attention,
                street1: newData.billing.street1,
                street2: newData.billing.street2,
                phone: newData.billing.phone,
                city: newData.billing.city,
                state: newData.billing.state,
                zip: newData.billing.zip,
                country: newData.billing.country,
                isPrimary: newData.billing.isPrimary,

                phoneMechId: res.data.customer.billing.phoneMechId,
                postalMechId: res.data.customer.billing.postalMechId,
              });
              this.setState(
                {
                  billingDetails: addressDetails,
                  addressDetails: addressDetails,
                },
                () => {
                  this.setState({
                    addAddressDetailDialog: false,
                    displayForm: false,
                    loading: false,
                  });
                  this.handleDialog(false);
                  this.props.reloadCustomerData();
                },
              );
            }
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
          });
        });
    }
  };

  removeAddress = (address, index) => {
    this.setState({ loading: true });
    BusApiCall(
      "DELETE",
      `${constants.busV4Url}/customers/${this.props.partyId}/addresses/${address.postalMechId}`,
    )
      .then((res) => {
        if (res.data.responseMessage === "success") {
          let addressDetails = [...this.state.addressDetails];
          addressDetails.splice(index, 1);
          this.setState(
            {
              addressDetails: addressDetails,
            },
            () => {
              this.setState({ loading: false });
              this.props.reloadCustomerData();
              this.props.setErrorMessage(
                this.props.t("ADDRESS_REMOVED_SUCCESSFULLY"),
                true,
              );
            },
          );
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  editAddressDetailDialog = (address, index) => {
    this.setStateListChange(address.country);
    this.setState({
      attention: address.attention,
      phone: address.phone,
      street1: address.street1,
      street2: address.street2,
      city: address.city,
      state: address.state,
      zip: address.zip,
      country: address.country,
      postalMechId: address.postalMechId,
      editAddressDetailDialog: true,
    });
  };

  //handle a dialog
  handleDialog = (action) => {
    if (!action) {
      //clear state when false is opted
      this.setState({
        attention: "",
        phone: "",
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        isPrimary: false,
        addressError: {
          message: "",
          show: false,
        },
      });
    }
    this.setState({
      addAddressDetailDialog: action,
      editAddressDetailDialog: action,
    });
  };

  addAddressDetailDialog = () => {
    this.setStateListChange(this.props.defaultCountry);
    this.setState({
      country: this.props.defaultCountry,
      addAddressDetailDialog: true,
    });
  };

  setAddressAsPrimary = (e, index) => {
    this.setState({
      loading: true,
    });
    let contactMechId = this.state.addressDetails[index].postalMechId;
    let data = {
      type: "address",
      isPrimary: true,
      contactMechId: contactMechId,
    };

    this.setState(
      {
        isPrimary: e.target.checked,
      },
      () => {
        BusApiCall(
          "POST",
          `${constants.busV4Url}/customers/${this.props.partyId}/primary`,
          data,
        )
          .then((res) => {
            for (var i = 0; i < this.state.addressDetails.length; i++) {
              if (i === index) {
                this.state.addressDetails[i].isPrimary = true;
              } else {
                this.state.addressDetails[i].isPrimary = false;
              }
            }
            this.setState({
              loading: false,
            });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      },
    );
  };
  setSelectedBillingAddress = (index) => {
    this.setState({
      selectedBillingAddress: index,
    });
  };

  setCountryName = (country) => {
    var list = this.props.countriesList;
    var index = list.findIndex((a) => a.id === country);
    if (index > -1) {
      return list[index].name;
    } else {
      return country;
    }
    // var list = stateCode.country;
    // for (var i = 0; i < list.length; i++) {
    //     if (list[i].abbreviation === code) {
    //         return list[i].name;
    //     }
    // }
  };

  validateMobileNumber = (mobileNumber) => {
    const mobileNumberRegex =
      /^[+]?[0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$|^[\+][1][-][0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$/;
    if (!mobileNumberRegex.test(mobileNumber)) {
      return false;
    }
    return true;
  };

  formDialogTitle = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#form-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  setStateListChange = (country) => {
    this.setState({
      loading: true,
    });
    getStatesList(country)
      .then((res) => {
        this.setState({
          statesList: res,
          state: res.length > 0 ? res[0].id : "",
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("FAILED_TO_LOAD_STATES"),
            false,
          );
        }
      });
  };
  render() {
    const { t } = this.props;
    const { error } = this.state;
    // const { classes } = this.props;
    return (
      <Box
        className="roundCorners"
        style={{
          border: "1px solid lightgrey",
          marginTop: "1rem",
          padding: "1.5rem",
        }}
      >
        <div>
          <Loader loading={this.state.loading} />
          <div
            style={{
              marginBottom: this.props.screen === "paymentMethod" ? "2rem" : 0,
              minHeight: "1rem",
            }}
          >
            <h3 style={{ marginTop: 0, float: "left", width: "60%" }}>
              {this.props.tabValue === 1
                ? t("SHIPPING_ADDRESS")
                : t("BILLING_ADDRESS")}
            </h3>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              {this.props.screen !== "checkout" &&
                this.state.addressDetails.length > 0 && (
                  <>
                    {!this.state.displayForm &&
                      this.props.screen !== "paymentMethod" && (
                        <>
                          {this.props.loggedInUserType !==
                            "ECOMMERCE_CUSTOMER" &&
                            this.props.userPerms.includes("PARTYMGR_ADMIN") && (
                              <Button
                                className={"buttonSecondary"}
                                style={{ float: "right" }}
                                onClick={() => this.addAddressDetailDialog()}
                              >
                                <span
                                  style={{
                                    marginRight: ".25rem",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                                {t("ADD_ADDRESS")}
                              </Button>
                            )}
                        </>
                      )}
                  </>
                )}
            </div>
          </div>
          {this.state.addressDetails.length === 0 && (
            <Grid container spacing={2} align="center">
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                {t("NO_BILLING_ADDRESS_AVAILABLE")}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                {!this.state.displayForm &&
                  this.props.screen !== "paymentMethod" && (
                    <>
                      {this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                        this.props.userPerms.includes("PARTYMGR_ADMIN") && (
                          <Button
                            className={"buttonSecondary"}
                            onClick={() => this.addAddressDetailDialog()}
                          >
                            <span
                              style={{
                                marginRight: ".25rem",
                                verticalAlign: "middle",
                              }}
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {t("ADD_ADDRESS")}
                          </Button>
                        )}
                    </>
                  )}
              </Grid>
            </Grid>
          )}
          {this.state.addressDetails.map((address, index) => (
            <Box
              className="roundCorners"
              style={{ border: "1px solid lightgrey", marginTop: "1rem" }}
            >
              <Grid
                container
                style={{
                  padding: "1rem",
                  flexWrap: "wrap",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Grid
                  item
                  style={{ flex: "0 1 40px", minWidth: 0, marginBottom: 8 }}
                >
                  {this.props.screen === "paymentMethod" ? (
                    <Tooltip title={t("MAKE_DEFAULT")}>
                      <div className={classes.round}>
                        <input
                          type="checkbox"
                          readOnly
                          checked={this.state.selectedBillingAddress === index}
                        />
                        <label
                          htmlFor="checkbox"
                          onClick={(event) => {
                            this.props.setPaymentBillingAddress(address, index);
                            this.setSelectedBillingAddress(index);
                          }}
                        ></label>
                      </div>
                    </Tooltip>
                  ) : (
                    <Tooltip title={t("MAKE_DEFAULT")}>
                      <div className={classes.round}>
                        <input
                          type="checkbox"
                          readOnly
                          checked={address.isPrimary}
                        />
                        <label
                          htmlFor="checkbox"
                          onClick={(event) =>
                            this.setAddressAsPrimary(event, index)
                          }
                        ></label>
                      </div>
                    </Tooltip>
                  )}
                </Grid>
                <Grid
                  item
                  style={{ flex: "3 1 200px", minWidth: 0, marginBottom: 8 }}
                  onClick={() => {
                    this.props.screen === "checkout" &&
                      this.props.chooseExistingCustomerDetail(
                        address,
                        this.props.tabValue,
                      );
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <div style={{ maxWidth: "20rem" }}>
                      {address.street1},{" "}
                      {address.street2 !== "" ? address.street2 + "," : ""}{" "}
                      {address.city}, {address.state} {address.zip},{" "}
                      {this.setCountryName(address.country)}
                    </div>
                  </div>
                  <div style={{ color: "#717784" }}>
                    <span>{t("ATTENTION")}:</span>
                    <span> {address.attention}</span>
                  </div>
                  {address.phone && (
                    <div style={{ color: "#717784" }}>
                      <span>{t("PHONE")}:</span>
                      <span> {address.phone}</span>
                    </div>
                  )}
                </Grid>
                <Grid
                  item
                  style={{
                    flex: "1 1 180px",
                    minWidth: 0,
                    marginBottom: 8,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                  }}
                >
                  {address.isPrimary && (
                    <Chip
                      size="normal"
                      className={"blueChip"}
                      style={{ padding: "0.6rem" }}
                      label={t("DEFAULT_ADDRESS")}
                    />
                  )}
                  {/* </Grid> */}
                  {this.props.screen !== "paymentMethod" &&
                    this.props.screen !== "checkout" && (
                      // <<Grid item style={{ flex: "1 1 120px", minWidth: 0, marginBottom: 8}}>
                      <>
                        {this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                          this.props.userPerms.includes("PARTYMGR_ADMIN") && (
                            <Button
                              className="buttonSecondary"
                              onClick={() =>
                                this.editAddressDetailDialog(address, index)
                              }
                            >
                              {/* {t("EDIT")} */}
                              <svg
                                width="16"
                                height="15"
                                viewBox="0 0 13 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </Button>
                          )}
                        {this.props.screen === "paymentMethod"
                          ? this.state.selectedBillingAddress &&
                            this.props.userPerms.includes("PARTYMGR_ADMIN") && (
                              <Button
                                onClick={() => {
                                  this.removeAddress(address, index);
                                }}
                                className={"buttonSecondary"}
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M4 1.5C4 1.22386 4.22386 1 4.5 1H7.5C7.77614 1 8 1.22386 8 1.5C8 1.77614 7.77614 2 7.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM2.49612 2.5H1.5C1.22386 2.5 1 2.72386 1 3C1 3.27614 1.22386 3.5 1.5 3.5H2.03222L2.35307 8.31272C2.37825 8.69044 2.39908 9.00302 2.43644 9.25744C2.47533 9.52234 2.53702 9.76441 2.66555 9.99C2.86562 10.3412 3.16739 10.6235 3.53111 10.7998C3.76476 10.913 4.0104 10.9585 4.2773 10.9797C4.53364 11 4.84691 11 5.22547 11H6.77453C7.15309 11 7.46636 11 7.7227 10.9797C7.9896 10.9585 8.23524 10.913 8.46889 10.7998C8.83261 10.6235 9.13439 10.3412 9.33446 9.99C9.46298 9.76441 9.52467 9.52234 9.56356 9.25744C9.60092 9.003 9.62176 8.6904 9.64693 8.31265L9.96778 3.5H10.5C10.7761 3.5 11 3.27614 11 3C11 2.72386 10.7761 2.5 10.5 2.5H9.50388C9.50096 2.49997 9.49804 2.49997 9.49513 2.5H2.50487C2.50196 2.49997 2.49904 2.49997 2.49612 2.5ZM8.96556 3.5H3.03444L3.34954 8.22639C3.37637 8.62889 3.39492 8.90168 3.42583 9.11217C3.45585 9.31663 3.49252 9.42143 3.53444 9.495C3.63447 9.6706 3.78536 9.81176 3.96722 9.89989C4.04342 9.93682 4.15043 9.96645 4.35643 9.9828C4.56851 9.99963 4.84193 10 5.24533 10H6.75467C7.15807 10 7.43149 9.99963 7.64357 9.9828C7.84957 9.96645 7.95658 9.93682 8.03278 9.89989C8.21464 9.81176 8.36553 9.6706 8.46556 9.495C8.50748 9.42143 8.54415 9.31663 8.57417 9.11217C8.60508 8.90168 8.62363 8.62889 8.65046 8.22639L8.96556 3.5ZM5 4.75C5.27614 4.75 5.5 4.97386 5.5 5.25V7.75C5.5 8.02614 5.27614 8.25 5 8.25C4.72386 8.25 4.5 8.02614 4.5 7.75V5.25C4.5 4.97386 4.72386 4.75 5 4.75ZM7 4.75C7.27614 4.75 7.5 4.97386 7.5 5.25V7.75C7.5 8.02614 7.27614 8.25 7 8.25C6.72386 8.25 6.5 8.02614 6.5 7.75V5.25C6.5 4.97386 6.72386 4.75 7 4.75Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </Button>

                              // <Delete
                              // 	style={{ float: "right" }}
                              // onClick={() => {
                              // 	this.removeAddress(address, index);
                              // }}
                              // />
                            )
                          : !address.isPrimary &&
                            this.props.userPerms.includes("PARTYMGR_ADMIN") && (
                              <Button
                                onClick={() => {
                                  this.removeAddress(address, index);
                                }}
                                className={"buttonSecondary"}
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M4 1.5C4 1.22386 4.22386 1 4.5 1H7.5C7.77614 1 8 1.22386 8 1.5C8 1.77614 7.77614 2 7.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM2.49612 2.5H1.5C1.22386 2.5 1 2.72386 1 3C1 3.27614 1.22386 3.5 1.5 3.5H2.03222L2.35307 8.31272C2.37825 8.69044 2.39908 9.00302 2.43644 9.25744C2.47533 9.52234 2.53702 9.76441 2.66555 9.99C2.86562 10.3412 3.16739 10.6235 3.53111 10.7998C3.76476 10.913 4.0104 10.9585 4.2773 10.9797C4.53364 11 4.84691 11 5.22547 11H6.77453C7.15309 11 7.46636 11 7.7227 10.9797C7.9896 10.9585 8.23524 10.913 8.46889 10.7998C8.83261 10.6235 9.13439 10.3412 9.33446 9.99C9.46298 9.76441 9.52467 9.52234 9.56356 9.25744C9.60092 9.003 9.62176 8.6904 9.64693 8.31265L9.96778 3.5H10.5C10.7761 3.5 11 3.27614 11 3C11 2.72386 10.7761 2.5 10.5 2.5H9.50388C9.50096 2.49997 9.49804 2.49997 9.49513 2.5H2.50487C2.50196 2.49997 2.49904 2.49997 2.49612 2.5ZM8.96556 3.5H3.03444L3.34954 8.22639C3.37637 8.62889 3.39492 8.90168 3.42583 9.11217C3.45585 9.31663 3.49252 9.42143 3.53444 9.495C3.63447 9.6706 3.78536 9.81176 3.96722 9.89989C4.04342 9.93682 4.15043 9.96645 4.35643 9.9828C4.56851 9.99963 4.84193 10 5.24533 10H6.75467C7.15807 10 7.43149 9.99963 7.64357 9.9828C7.84957 9.96645 7.95658 9.93682 8.03278 9.89989C8.21464 9.81176 8.36553 9.6706 8.46556 9.495C8.50748 9.42143 8.54415 9.31663 8.57417 9.11217C8.60508 8.90168 8.62363 8.62889 8.65046 8.22639L8.96556 3.5ZM5 4.75C5.27614 4.75 5.5 4.97386 5.5 5.25V7.75C5.5 8.02614 5.27614 8.25 5 8.25C4.72386 8.25 4.5 8.02614 4.5 7.75V5.25C4.5 4.97386 4.72386 4.75 5 4.75ZM7 4.75C7.27614 4.75 7.5 4.97386 7.5 5.25V7.75C7.5 8.02614 7.27614 8.25 7 8.25C6.72386 8.25 6.5 8.02614 6.5 7.75V5.25C6.5 4.97386 6.72386 4.75 7 4.75Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </Button>
                              // <Delete
                              // 	style={{ float: "right" }}
                              // 	onClick={() => {
                              // 		this.removeAddress(address, index);
                              // 	}}
                              // />
                            )}
                        {/* </Grid> */}
                      </>
                    )}
                  {this.state.addressDetails.length === 0 && (
                    <Grid container spacing={2} align="center">
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        {t("NO_BILLING_ADDRESS_AVAILABLE")}
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        {!this.state.displayForm &&
                          this.props.screen !== "paymentMethod" && (
                            <>
                              {this.props.loggedInUserType !==
                                "ECOMMERCE_CUSTOMER" &&
                                this.props.userPerms.includes(
                                  "PARTYMGR_ADMIN",
                                ) && (
                                  <Button
                                    className={"buttonSecondary"}
                                    style={{ float: "right" }}
                                    onClick={() =>
                                      this.addAddressDetailDialog()
                                    }
                                  >
                                    <span
                                      style={{
                                        marginRight: ".25rem",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {t("ADD_ADDRESS")}
                                  </Button>
                                )}
                            </>
                          )}
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Box>
          ))}

          {/* Add Address Detail Dialog Starts */}
          {this.state.addAddressDetailDialog && (
            <Dialog
              open={this.state.addAddressDetailDialog}
              aria-labelledby="form-dialog-title"
              fullWidth={true}
              maxWidth={"sm"}
              PaperComponent={this.formDialogTitle}
              PaperProps={
                {
                  // className: classes.resizablePaper
                }
              }
            >
              <DialogTitle
                id="form-dialog-title"
                className={classes.paymentMethods}
                style={{ cursor: "move" }}
              >
                <div style={{ display: "flex" }}>
                  <span style={{ display: "inline-flex", width: "95%" }}>
                    {this.props.tabValue === 1 && t("NEW_SHIPPING_ADDRESS")}
                    {this.props.tabValue === 2 && t("NEW_BILLING_ADDRESS")}
                  </span>
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onTouchStart={() => this.handleDialog(false)}
                      onClick={() => this.handleDialog(false)}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers>
                <Grid container spacing={2}>
                  {/* <Grid item xs={3}> {t('ATTENTION')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <Input
                      error={!!error.attention}
                      helperText={error.attention}
                      size={"small"}
                      variant={"outlined"}
                      name={"attention"}
                      value={this.state.attention}
                      placeholder={t("ATTENTION") + " *"}
                      onChange={(e) => {
                        this.setAddress(e);
                        this.setState({
                          error: {
                            ...this.state.error,
                            attention: "",
                          },
                        });
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={3}> {t('STREET1')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <Input
                      error={!!error.street1}
                      helperText={error.street1}
                      size={"small"}
                      variant={"outlined"}
                      name={"street1"}
                      value={this.state.street1}
                      placeholder={t("STREET1") + " *"}
                      onChange={(e) => {
                        this.setAddress(e);
                        this.setState({
                          error: {
                            ...this.state.error,
                            street1: "",
                          },
                        });
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={3}> {t('STREET2')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      name={"street2"}
                      value={this.state.street2}
                      placeholder={t("STREET2")}
                      onChange={(e) => {
                        this.setAddress(e);
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <InputPhone
                      error={!!error.phone}
                      helperText={error.phone}
                      size={"small"}
                      variant={"outlined"}
                      name={"phone"}
                      value={this.state.phone}
                      placeholder={t("PHONE")}
                      onChange={(e) => {
                        this.setAddress(e);
                        this.setState({
                          error: {
                            ...this.state.error,
                            phone: "",
                          },
                        });
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={3}> {t('CITY')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <Input
                      error={!!error.city}
                      helperText={error.city}
                      name={"city"}
                      size={"small"}
                      variant={"outlined"}
                      value={this.state.city}
                      placeholder={t("CITY") + " *"}
                      onChange={(e) => {
                        this.setAddress(e);
                        this.setState({
                          error: {
                            ...this.state.error,
                            city: "",
                          },
                        });
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={3}> {t('ZIP')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <Input
                      error={!!error.zip}
                      helperText={error.zip}
                      name={"zip"}
                      size={"small"}
                      variant={"outlined"}
                      value={this.state.zip}
                      placeholder={t("ZIP")}
                      onChange={(e) => {
                        this.setAddress(e);
                        // this.setState({
                        // 	error: {
                        // 		...this.state.error,
                        // 		zip: "",
                        // 	},
                        // });
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={3}> {t('COUNTRY')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <FormControl
                      variant={"outlined"}
                      size={"small"}
                    >
                      <InputLabel id="country">
                        {" "}
                        {t("SELECT_COUNTRY") + " *"}
                      </InputLabel>
                      <Select
                        native
                        label={t("SELECT_COUNTRY") + " *"}
                        value={this.state.country}
                        labelId="country"
                        inputProps={{
                          name: "country",
                        }}
                        onChange={(e) => {
                          this.setAddress(e);
                          this.setState({ state: "" });
                          this.setStateListChange(e.target.value);
                        }}
                      >
                        {this.props.countriesList.map((a) => (
                          <option key={a.id} value={a.id}>
                            {a.name}
                          </option>
                        ))}
                        {/* {stateCode.country.map(a => (
                                            <option key={a.abbreviation} value={a.abbreviation}>{a.name}</option>
                                        ))} */}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* <Grid item xs={3}> {t('STATE')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <FormControl
                      variant={"outlined"}
                      size={"small"}
                      error={!!error.state}
                    >
                      <InputLabel id="stateLabel">
                        {" "}
                        {t("SELECT_STATE") + " *"}
                      </InputLabel>
                      <Select
                        native
                        label={t("SELECT_STATE") + " *"}
                        labelId="stateLabel"
                        onChange={(e) => {
                          this.setAddress(e);
                          this.setState({
                            error: {
                              ...this.state.error,
                              state: "",
                            },
                          });
                        }}
                        value={this.state.state}
                        inputProps={{
                          name: "state",
                          id: "state",
                        }}
                      >
                        {/* {stateCode.state[this.state.country].map(a => (
                                                <option key={a.abbreviation} value={a.abbreviation}>{a.name}</option>
                                            ))} */}
                        {this.state.statesList.map((a) => (
                          <option key={a.id} value={a.id}>
                            {a.name}
                          </option>
                        ))}
                      </Select>
                      {error.state && (
                        <span
                          className="text-error"
                          style={{
                            marginLeft: "0px",
                            marginTop: "4px",
                          }}
                        >
                          {error.state}
                        </span>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    &nbsp;&nbsp;
                    {this.state.addressDetails.length === 0 ? (
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            name={"isPrimary"}
                            checked={true}
                            readOnly={true}
                          />
                        }
                        label={t("SET_AS_DEFAULT")}
                        onChange={(event) => this.setPrimaryMethod(event)}
                      />
                    ) : (
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            name={"isPrimary"}
                            checked={this.state.isPrimary}
                          />
                        }
                        label={t("SET_AS_DEFAULT")}
                        onChange={(event) => this.setPrimaryMethod(event)}
                      />
                    )}
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions
                style={{
                  justifyContent: this.state.addressError.show
                    ? "space-between"
                    : "flex-end",
                }}
              >
                {this.state.addressError.show && (
                  <span item xs={12} className={classes.paymentMethodsError}>
                    {this.state.addressError.message}
                  </span>
                )}
                <div>
                  {/* <Button onClick={event => this.handleDialog(false)} style={{ marginRight: '10px' }} color="primary">{t('CANCEL')}</Button> */}
                  <Button
                    onClick={(event) => this.createCustomerProfile()}
                    color="primary"
                  >
                    {t("ADD")}
                  </Button>
                </div>

                {/* <Button style={{float: 'right'}} onClick={() => this.createCustomerProfile()}>Submit</Button>
                        <Button style={{float: 'right'}} onClick={() => this.hideAddressDetails()}>Cancel</Button> */}
              </DialogActions>
            </Dialog>
          )}

          {/* Edit Address Detail Dialog Starts */}
          {this.state.editAddressDetailDialog && (
            <Dialog
              open={this.state.editAddressDetailDialog}
              aria-labelledby="form-dialog-title"
              fullWidth={true}
              maxWidth={"sm"}
              PaperComponent={this.formDialogTitle}
              PaperProps={
                {
                  // className: classes.resizablePaper
                }
              }
            >
              <DialogTitle
                id="form-dialog-title"
                style={{ cursor: "move" }}
                className={classes.paymentMethods}
              >
                <div style={{ display: "flex" }}>
                  <span style={{ display: "inline-flex", width: "95%" }}>
                    {this.state.dialogTitle
                      ? this.state.dialogTitle
                      : t("EDIT_ADDRESS")}
                  </span>
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onTouchStart={() => this.handleDialog(false)}
                      onClick={() => this.handleDialog(false)}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers>
                <Grid container spacing={2}>
                  {/* <Grid item xs={3}> {t('ATTENTION')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <Input
                      error={!!error.attention}
                      helperText={error.attention}
                      size={"small"}
                      variant={"outlined"}
                      name={"attention"}
                      value={this.state.attention}
                      placeholder={t("ATTENTION") + " *"}
                      onChange={(e) => {
                        this.updateChange(e);
                        this.setState({
                          error: {
                            ...this.state.error,
                            attention: "",
                          },
                        });
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={3}> {t('STREET1')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <Input
                      error={!!error.street1}
                      helperText={error.street1}
                      size={"small"}
                      variant={"outlined"}
                      name={"street1"}
                      value={this.state.street1}
                      placeholder={t("STREET1") + " *"}
                      onChange={(e) => {
                        this.updateChange(e);
                        this.setState({
                          error: {
                            ...this.state.error,
                            street1: "",
                          },
                        });
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={3}> {t('STREET2')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      name={"street2"}
                      value={this.state.street2}
                      placeholder={t("STREET2")}
                      onChange={(e) => {
                        this.updateChange(e);
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <InputPhone
                      error={!!error.phone}
                      helperText={error.phone}
                      size={"small"}
                      variant={"outlined"}
                      name={"phone"}
                      value={this.state.phone}
                      placeholder={t("PHONE")}
                      onChange={(e) => {
                        this.updateChange(e);
                        this.setState({
                          error: {
                            ...this.state.error,
                            phone: "",
                          },
                        });
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={3}> {t('CITY')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <Input
                      error={!!error.city}
                      helperText={error.city}
                      name={"city"}
                      size={"small"}
                      variant={"outlined"}
                      value={this.state.city}
                      placeholder={t("CITY") + " *"}
                      onChange={(e) => {
                        this.updateChange(e);
                        this.setState({
                          error: {
                            ...this.state.error,
                            city: "",
                          },
                        });
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={3}> {t('ZIP')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <Input
                      error={!!error.zip}
                      helperText={error.zip}
                      name={"zip"}
                      size={"small"}
                      variant={"outlined"}
                      value={this.state.zip}
                      placeholder={t("ZIP")}
                      onChange={(e) => {
                        this.updateChange(e);
                        // this.setState({
                        // 	error: {
                        // 		...this.state.error,
                        // 		zip: "",
                        // 	},
                        // });
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={3}> {t('COUNTRY')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <FormControl
                      variant="outlined"
                      size={"small"}
                    >
                      <InputLabel
                        id="country"
                      >
                        {" "}
                        {t("COUNTRY") + " *"}
                      </InputLabel>
                      <Select
                        native
                        labelId="country"
                        label={t("COUNTRY") + " *"}
                        value={this.state.country}
                        onChange={(e) => {
                          this.updateChange(e);
                          this.setStateListChange(e.target.value);
                        }}
                        inputProps={{
                          name: "country",
                        }}
                      >
                        {this.props.countriesList.map((a) => (
                          <option key={a.id} value={a.id}>
                            {a.name}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* <Grid item xs={3}> {t('STATE')} </Grid> */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                    }}
                  >
                    <FormControl
                      variant="outlined"
                      size={"small"}
                      error={!!error.state}
                    >
                      <InputLabel
                        id="stateLabel"
                      >
                        {" "}
                        {t("STATE") + " *"}
                      </InputLabel>
                      <Select
                        native
                        labelId="stateLabel"
                        label={t("STATE") + " *"}
                        value={this.state.state}
                        onChange={(e) => {
                          this.updateChange(e);
                          this.setState({
                            error: {
                              ...this.state.error,
                              state: "",
                            },
                          });
                        }}
                        inputProps={{
                          name: "state",
                          id: "state",
                        }}
                      >
                        {this.state.statesList.map((a) => (
                          <option key={a.id} value={a.id}>
                            {a.name}
                          </option>
                        ))}
                      </Select>
                      {error.state && (
                        <span
                          className="text-error"
                            style={{
                            marginLeft: "0px",
                            marginTop: "4px",
                          }}
                        >
                          {error.state}
                        </span>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions
                style={{
                  justifyContent: this.state.addressError.show
                    ? "space-between"
                    : "flex-end",
                }}
              >
                {this.state.addressError.show && (
                  <span item xs={12} className={classes.paymentMethodsError}>
                    {this.state.addressError.message}
                  </span>
                )}
                <div>
                  {/* <Button onClick={event => this.handleDialog(false)} style={{ marginRight: '10px' }} color="primary">{t('CANCEL')}</Button> */}
                  <Button
                    onClick={(event) => this.updateCustomerAddress()}
                    color="primary"
                  >
                    {t("UPDATE")}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
          )}
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    loggedInUserType: state.auth.userLoginType,
    countriesList: state.global.countriesList,
    defaultCountry: state.auth.defaultCountry,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

// export default connect(mapStateToProps, mapDispatchToProps)(withTranslation("translations")(withStyles(styles)(AddressDetails)))
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(AddressDetails));
